import type { JSX } from 'react';

import classNames from 'classnames';

import styles from './Alert.module.css';

interface AlertProps extends React.ComponentProps<'div'> {
  variant?: 'default' | 'success' | 'warn' | 'warning' | 'danger' | 'destructive' | 'info';
  children: React.ReactNode;
}

export function Alert({
  variant = 'default',
  className,
  children,
  ...props
}: AlertProps): JSX.Element {
  return (
    <div
      role="alert"
      className={classNames(styles.Alert, styles[variant], className)}
      {...props}
    >
      {children}
    </div>
  );
}

interface AlertTitleProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
}

export function AlertTitle({
  className,
  children,
  ...props
}: AlertTitleProps): JSX.Element {
  return (
    <div className={classNames(styles.AlertTitle, className)} {...props}>
      {children}
    </div>
  );
}

interface AlertDescriptionProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
}

export function AlertDescription({
  className,
  children,
  ...props
}: AlertDescriptionProps): JSX.Element {
  return (
    <div className={classNames(styles.AlertDescription, className)} {...props}>
      {children}
    </div>
  );
}

